import React, { useContext, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';

import TopBar from '../Topbar/TopBar';
import SideBar from '../SideBar/SideBar';
import { AuthContext } from '../../providers/AuthProvider'

const ProtectedLayout = () => {
  let navigate = useNavigate();
  const { authState, isAuthenticated } = useContext(AuthContext)

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true })
    }
  }, [isAuthenticated, navigate])


  return (
    <>
      <TopBar />
      <SideBar />
      <Outlet />
      {
        authState.authenticated && <Outlet />
      }
    </>
  )
}

export default ProtectedLayout;